<template>
  <div>
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <div class="px-3">
      <div :class="isMobile ? '' : ''" :style="isMobile ? '' : ''">
        <div>
          <p v-if="!hasSessionToReplace()">
            لطفاً اطلاعات زیر را برای ثبت جلسه تکمیل کنید:
          </p>
          <p v-else>
            به منظور
            <span class="fw-bold text-danger-gradient blinkText"
              >جابجایی جلسه</span
            >
            اطلاعات زیر را تکمیل نمایید
          </p>
        </div>
        <div
          class="row mt-2"
          :style="isMobile ? '' : 'max-height: 80vh;justify-content: center;'"
        >
          <div
            class="accordion col-md-5 col-sm-11"
            :class="isMobile ? 'm-auto' : 'my-0'"
          >
            <div class="accordion-item">
              <div class="accordion-header p-1">
                <h6 class="m-0">ثبت جلسه درمانی</h6>
              </div>
              <div class="accordion-collapse collapse show">
                <div class="accordion-body p-3 pb-1 mb-3">
                  <div>
                    <div class="row">
                      <div class="col-md-12">
                        <searchable-input
                          :required="true"
                          mode="single"
                          errorClass="text-danger"
                          placeHolder="نوع درمان را انتخاب نمایید"
                          errorText="انتخاب نوع درمان الزامی است."
                          ref="therapyTypeSelect"
                          id="therapyTypeSelect"
                          @multiSelectChanged="therapyTypeChanged"
                          :options="therapyTypeList"
                          v-model:inputValue="entity.therapyTypeID"
                          inputThem="purpleThem"
                          :disabled="hasSessionToReplace()"
                          :canDeselect="false"
                          topTitle="نوع درمان:"
                          :topTitleClass="
                            isMobile ? 'fs-8 fw-bold mb-1' : 'mb-1'
                          "
                          inputTitle=""
                        />
                        <searchable-input
                          :required="entity.therapyTypeID == 1"
                          errorClass="errorClass text-danger"
                          ref="scopeSelect"
                          :disabled="isScopeSelectDisabled"
                          errorText="انتخاب نوع تخصص الزامی است."
                          :placeHolder="
                            entity.therapyTypeID == 1
                              ? 'نوع تخصص را انتخاب نمایید'
                              : 'در نظر گرفته نشود'
                          "
                          :options="scopeList"
                          v-model:inputValue="entity.scopeIDs"
                          :hasSideBox="false"
                          @multiSelectChanged="scopeChanged"
                          inputThem="purpleThem"
                          topTitle="تخصص درمانگر:"
                          :canDeselect="false"
                          :canClear="true"
                          :topTitleClass="
                            isMobile ? 'fs-8 fw-bold mb-1 mt-1' : 'mt-1'
                          "
                        />
                        <searchable-input
                          v-if="showTopicFilter"
                          ref="topicSelect"
                          placeHolder="در نظر گرفته نشود"
                          :options="topicList"
                          v-model:inputValue="entity.topicIDs"
                          :hasSideBox="false"
                          :loading="isLoadingTopicList"
                          inputThem="purpleThem"
                          topTitle="موضوع جلسه:"
                          :canDeselect="false"
                          :canClear="true"
                          :topTitleClass="
                            isMobile ? 'fs-8 fw-bold mb-1 mt-1' : 'mt-1'
                          "
                        />
                      </div>
                      <!-- <div class="col-md-6" id="scopeSelect"></div> -->
                      <!-- <div
                        class="col-md-6 mt-2"
                        v-if="showTopicFilter"
                        id="topicSelect"
                      >
                        <searchable-input
                          ref="topicSelect"
                          placeHolder="در نظر گرفته نشود"
                          :options="topicList"
                          v-model:inputValue="entity.topicIDs"
                          :hasSideBox="false"
                          :loading="isLoadingTopicList"
                          inputThem="purpleThem"
                          topTitle="موضوع:"
                          :canDeselect="false"
                          :canClear="true"
                          topTitleClass="mt-1"
                        />
                      </div> 
                      <div
                        :class="
                          showTopicFilter ? 'col-12 searchAdvance' : 'col-12 '
                        "
                        class="text-center"
                        v-if="false"
                      >
                        <div class="">
                          <a
                            ref="isAdvanceSearchCollapsed"
                            @click="isAdvanceSearchCollapsed"
                            class="advanceSearchControl mt-2"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseOne"
                            aria-expanded="true"
                            aria-controls="panelsStayOpen-collapseOne"
                            ><svg
                              v-if="advanceSearchState == 'hide'"
                              width="18px"
                              height="18px"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              class="bi bi-caret-down-fill"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                              ></path>
                            </svg>
                            <svg
                              v-if="advanceSearchState == 'show'"
                              width="18px"
                              height="18px"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              class="bi bi-caret-up-fill"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                              ></path>
                            </svg>
                            جستجو پیشرفته
                          </a>
                        </div>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- v-if="
              showOtherAbilityFilter ||
              showApproachFilter ||
              showEducationDegreeFilter ||
              showAgeRangeFilter ||
              showGenderFilter
            " -->
          <div
            class="accordion col-md-8 col-sm-11"
            :class="isMobile ? 'm-auto' : 'my-0'"
            id="accordionPanelsStayOpenExample"
            v-if="false"
          >
            <div class="accordion-item">
              <div
                ref="panelsStayOpenCollapseOne"
                id="panelsStayOpen-collapseOne"
                class="accordion-collapse collapse"
                aria-labelledby="panelsStayOpen-headingOne"
              >
                <div class="accordion-body">
                  <div class="row">
                    <div class="col-md-6 col-sm-6" v-if="showGenderFilter">
                      <searchable-input
                        mode="single"
                        placeHolder="در نظر گرفته نشود"
                        :options="genderList"
                        v-model:inputValue="entity.genderID"
                        :hasSideBox="false"
                        inputThem="grayThem"
                        :canDeselect="true"
                        :canClear="true"
                        topTitle="جنسیت درمانگر: "
                        containerClass="mt-2"
                      />
                    </div>
                    <div class="col-md-6 col-sm-6" v-if="showAgeRangeFilter">
                      <searchable-input
                        mode="single"
                        placeHolder="در نظر گرفته نشود"
                        :options="ageRangeList"
                        v-model:inputValue="entity.ageRangeID"
                        :hasSideBox="false"
                        inputThem="grayThem"
                        :canDeselect="true"
                        :canClear="true"
                        topTitle="محدوده سنی درمانگر: "
                        containerClass="mt-2"
                      />
                    </div>
                    <div
                      class="col-md-6 col-sm-6"
                      v-if="showEducationDegreeFilter"
                    >
                      <searchable-input
                        mode="single"
                        placeHolder="در نظر گرفته نشود"
                        :options="educationList"
                        v-model:inputValue="entity.educationID"
                        :hasSideBox="false"
                        inputThem="grayThem"
                        :canDeselect="true"
                        :canClear="true"
                        topTitle="آخرین مدرک تحصیلی درمانگر: "
                        containerClass="mt-2"
                      />
                    </div>
                    <div class="col-md-6 col-sm-6" v-if="showApproachFilter">
                      <searchable-input
                        placeHolder="در نظر گرفته نشود"
                        :options="approachList"
                        v-model:inputValue="entity.approachIDs"
                        :hasSideBox="false"
                        inputThem="purpleThem"
                        topTitle="رویکردها: "
                        :canDeselect="false"
                        :canClear="true"
                        containerClass="mt-2"
                      />
                    </div>
                    <div
                      class="col-md-6 col-sm-6"
                      v-if="showOtherAbilityFilter"
                    >
                      <searchable-input
                        placeHolder="در نظر گرفته نشود"
                        :options="otherAbilityList"
                        v-model:inputValue="entity.otherAbilityIDs"
                        :hasSideBox="false"
                        inputThem="purpleThem"
                        topTitle="سایر توانایی‌ها: "
                        :canDeselect="false"
                        :canClear="true"
                        containerClass="mt-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="justify-content-between d-flex mb-2">
        <div class="previousStepRight">
          <button class="btn btn-sm m-2" @click="previousTab()">
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-arrow-right"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
              ></path>
            </svg>
            <span> گام قبلی </span>
          </button>
        </div>
        <div class="nextStepLeft">
          <button
            class="btn btn-sm btn-outline-danger m-2"
            @click="showCancelReplacingModal()"
            v-if="hasSessionToReplace()"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-x-lg"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
              ></path>
              <path
                fill-rule="evenodd"
                d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
              ></path>
            </svg>
            لغو عملیات جابجایی
          </button>
          <button
            class="btn btn-sm btn-danger"
            :class="isMobile ? 'm-2' : ''"
            @click="nextTab()"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-calendar-range"
              viewBox="0 0 16 16"
            >
              <path
                d="M9 7a1 1 0 0 1 1-1h5v2h-5a1 1 0 0 1-1-1zM1 9h4a1 1 0 0 1 0 2H1V9z"
              ></path>
              <path
                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
              ></path>
            </svg>
            <span> جدول جلسات </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import SearchableInput from '../../../../../components/form/searchableInput/SearchableInput.vue';
export default {
  components: {
    LoadingSpinner,
    SearchableInput,
  },
  inject: [
    'previousStep',
    'nextStep',
    'hasSessionToReplace',
    'showCancelReplacingModal',
  ],
  data() {
    return {
      isMobile: isMobile,
      advanceSearchState: 'hide',
      scopeList: [],
      originalScopeList: [],
      topicList: [],
      therapyTypeList: [],
      approachList: [],
      ageRangeList: [],
      genderList: [],
      educationList: [],
      otherAbilityList: [],
      isLoadingTopicList: false,

      showOtherAbilityFilter: true,
      showApproachFilter: true,
      showEducationDegreeFilter: true,
      showAgeRangeFilter: true,
      showGenderFilter: true,
      showTopicFilter: true,
      isScopeSelectDisabled: false,
      entity: {
        therapyTypeID: null,
        therapyTypeTitle: '',
        scopeIDs: [],
        topicIDs: [],
        approachIDs: [],
        otherAbilityIDs: [],
        ageRangeID: null,
        genderID: null,
        educationID: null,
      },
    };
  },
  props: {
    entityObject: {
      therapyTypeID: null,
      scopeIDs: [],
    },
  },
  methods: {
    async therapyTypeChanged(value) {
      this.entity.scopeIDs = [];
      this.entity.topicIDs = [];
      this.topicList = [];
      this.scopeList = this.originalScopeList;
      this.isScopeSelectDisabled = false;
      if (value != 1) {
        this.$refs.scopeSelect?.hideErrorMessage();
      }
      // اگر نوع درمان روانپزشکی بود حوزه باید روان‌بزشکی شود و غیرفعال
      if (value == 2) {
        this.scopeList = [
          {
            id: 8,
            label: 'روان‌پزشکی',
          },
        ];
        this.entity.scopeIDs = [8];
        this.entity.topicIDs = [];
        this.isScopeSelectDisabled = true;
        await this.scopeChanged(this.entity.scopeIDs);
      }
      // اگر نوع درمان روانسنجی بود حوزه باید روان‌سنجی(تست) شود و غیرفعال
      if (value == 14) {
        this.entity.scopeIDs = [7];
        this.entity.topicIDs = [];
        this.isScopeSelectDisabled = true;
        await this.scopeChanged(this.entity.scopeIDs);
      }
    },
    async scopeChanged(value) {
      if (value.length == 0) this.topicList = new Array();
      else {
        let backupTopics = this.entity.topicIDs;
        await this.getTopicList(this.entity.scopeIDs);
        this.entity.topicIDs = backupTopics;
      }
    },
    nextTab() {
      let isPass = true;
      //مقدار نوع درمان الزامی است
      if (this.entity.therapyTypeID == 0 || this.entity.therapyTypeID == null) {
        this.$refs.therapyTypeSelect.showErrorMessage();
        isPass = false;
      }
      // اگر نوع درمان روانشناسی بود حوزه الزامی است
      if (this.entity.therapyTypeID == 1 && this.entity.scopeIDs.length == 0) {
        this.$refs.scopeSelect.showErrorMessage();
        isPass = false;
      }
      if (!isPass) return;
      this.entity.therapyTypeTitle = this.therapyTypeList.find(
        (f) => f.id == this.entity.therapyTypeID
      ).label;
      this.nextStep(this.entity, 'filteringMore');
    },
    previousTab() {
      this.previousStep('filteringMore');
    },
    async isAdvanceSearchCollapsed() {
      // اگر اولین بار بود که جستجو پیشرفته باز میشد، مقادیر لیست‌هایش گرفته شود
      if (
        this.advanceSearchState == 'hide' &&
        this.ageRangeList.length == 0 &&
        this.genderList.length == 0 &&
        this.approachList.length == 0 &&
        this.otherAbilityList.length == 0 &&
        this.educationList.length == 0
      ) {
        this.$refs.spinner.show();
        await this.getAgeRangeList();
        await this.getGenderList();
        await this.getApproach();
        await this.getOtherAbilityList();
        await this.getEducationList();
        this.$refs.spinner.hide();
      }
      this.advanceSearchState =
        this.advanceSearchState == 'hide' ? 'show' : 'hide';
    },
    async getScopeList() {
      let that = this;
      await axios
        .get('/Basic/Scope/GetPublic')
        .then((response) => {
          that.scopeList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
          that.originalScopeList = that.scopeList;
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات حوزه‌ها با خطا مواجه گردید.`,
          });
        });
    },
    async getTopicList(scopeIDs) {
      let that = this;
      this.isLoadingTopicList = true;
      await axios
        .post('/Basic/Topic/GetPublicByScopeIDs', scopeIDs)
        .then((response) => {
          that.topicList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات موضوعات با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          that.isLoadingTopicList = false;
        });
    },
    async getTherapyTypeList() {
      let that = this;
      await axios
        .get('Basic/TherapyType/GetPublic')
        .then((response) => {
          that.therapyTypeList = response.data
            ?.filter((f) => f.id != 14)
            .map((m) => {
              return { id: m.id, label: m.title };
            });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات انواع جلسات با خطا مواجه گردید.`,
          });
        });
    },
    async getAgeRangeList() {
      let that = this;
      await axios
        .get('/Basic/AgeRange/GetPublic')
        .then((response) => {
          that.ageRangeList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات بازه‌های سنی با خطا مواجه گردید.`,
          });
        });
    },
    async getGenderList() {
      let that = this;
      await axios
        .get('/Basic/Gender/GetLookupForSite')
        .then((response) => {
          that.genderList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات جنسیت با خطا مواجه گردید.`,
          });
        });
    },
    async getEducationList() {
      let that = this;
      await axios
        .get('/Basic/Education/GetLookup')
        .then((response) => {
          that.educationList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات مدارک تحصیلی با خطا مواجه گردید.`,
          });
        });
    },
    async getOtherAbilityList() {
      let that = this;
      await axios
        .get('/Basic/OtherAbility/GetPublic')
        .then((response) => {
          that.otherAbilityList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات مدارک تحصیلی با خطا مواجه گردید.`,
          });
        });
    },
    async getApproach() {
      let that = this;
      await axios
        .get('/Basic/Approach/GetPublic')
        .then((response) => {
          that.approachList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات رویکردها با خطا مواجه گردید.`,
          });
        });
    },
  },
  async mounted() {
    this.$refs.spinner.show();
    await this.getScopeList();
    await this.getTherapyTypeList();
    // اگر از طریق رزور سریع به این صفحه هدایت شد مقادیر حوزه و نوع درمان مقدار دهی شود.
    // if (
    //   this.entityObject.therapistStatus == 'dontCareTherapist' &&
    //   this.entityObject.therapyTypeID != 0 &&
    //   ((this.entityObject.therapyTypeID == 1 &&
    //     this.entityObject.scopeIDs.length != 0) ||
    //     this.entityObject.therapyTypeID != 1)
    // ) {

    this.entity.therapyTypeID = this.entityObject.therapyTypeID;
    await this.therapyTypeChanged(this.entity.therapyTypeID);
    if (this.entity.therapyTypeID != 2 && this.entity.therapyTypeID != 14) {
      this.entity.scopeIDs = this.entityObject.scopeIDs;
      this.entity.topicIDs = this.entityObject.topicIDs;
    }
    if (
      this.entityObject.genderID != null ||
      this.entityObject.ageRangeID != null ||
      this.entityObject.educationID != null ||
      this.entityObject.approachIDs.length != 0 ||
      this.entityObject.otherAbilityIDs.length != 0
    ) {
      await this.isAdvanceSearchCollapsed();
      this.entity.genderID = this.entityObject.genderID;
      this.entity.ageRangeID = this.entityObject.ageRangeID;
      this.entity.educationID = this.entityObject.educationID;
      this.entity.approachIDs = this.entityObject.approachIDs;
      this.entity.otherAbilityIDs = this.entityObject.otherAbilityIDs;

      //تغییر حالت دکمه‌ی تنظیمات پیشرفته
      this.$refs.isAdvanceSearchCollapsed.classList.remove('collapsed');
      this.$refs.isAdvanceSearchCollapsed.setAttribute('aria-expanded', 'true');
      this.$refs.panelsStayOpenCollapseOne.classList.add('show');
    }
    // }
    let that = this;
    that.showOtherAbilityFilter =
      that.$store.getters.showOtherAbilityFilter == 'true' ? true : false;

    that.showApproachFilter =
      that.$store.getters.showApproachFilter == 'true' ? true : false;

    that.showEducationDegreeFilter =
      that.$store.getters.showEducationDegreeFilter == 'true' ? true : false;

    that.showAgeRangeFilter =
      that.$store.getters.showAgeRangeFilter == 'true' ? true : false;

    that.showGenderFilter =
      that.$store.getters.showGenderFilter == 'true' ? true : false;

    that.showTopicFilter =
      that.$store.getters.showTopicFilter == 'true' ? true : false;

    this.$refs.spinner.hide();
  },
};
</script>
<style scoped>
#therapyTypeSelect {
  margin-bottom: 1.5rem;
}
.accordion-header,
.accordion-button,
.collapsed {
  color: white;
  background-color: #4c5e74;
  border-radius: 5px 5px 0px 0px;
}
a.collapsed,
.advanceSearchControl {
  color: unset;
  background-color: unset !important;
  border-radius: unset !important;
}
.searchAdvance {
  margin-top: 2.1rem;
}
@media (max-width: 768px) {
  #therapyTypeSelect {
    margin-bottom: 0px;
  }
  .searchAdvance {
    margin-top: 0px;
  }
}
</style>
